/* eslint-disable sort-keys */
export const PLAYER_TYPES = {
  LESSON_PLAYER: 'lesson-player',
  LEARNOSITY_PLAYER: 'learnosity-player',
  LEARNOSITY_SCORING_PLAYER: 'learnosity-scoring-player',
  FILE_VIEWER: 'file-viewer',
  CONTENT_PREVIEW_PLAYER: 'content-viewer',
  DOCREADER_VIEWER: 'docreader-viewer'
};
